export enum AfterSalesStatusEnum {
  ACTIVE = 'ACTIVE',
  PARTNER_IN_PROCESS = 'PARTNER_IN_PROCESS',
  SUSPENDED = 'SUSPENDED',
  CANCELED = 'CANCELED',
}
